import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import Dashboard from '../pages/cqcCentre/Dashboard'
import EvidenceLibrary from '../pages/cqcCentre/Evidence/EvidenceLibrary'
import GapsList from '../pages/cqcCentre/Gaps/GapsList'
import MyGaps from '../pages/cqcCentre/Gaps/MyGaps'
import ComplianceQuestions from '../pages/cqcCentre/Compliance/ComplianceQuestions'
import CqcSettings from '../pages/cqcCentre/Settings/CqcSettings'
import CqcPackPage from '../pages/cqcCentre/Pack/CqcPackPage'
import RegistrationDashboard from '../pages/registration/Dashboard'
import ActivitiesList from '../pages/registration/Activities/ActivitiesList'
import AssessmentsList from '../pages/registration/Assessment/AssessmentsList'
import SopBuilder from '../pages/registration/StatementOfPurpose/SopBuilder'
import SopPackPage from '../pages/registration/StatementOfPurpose/SopPackPage'
import RegistrationSettings from '../pages/registration/Settings/RegistrationSettings'

export default [
  {
    element: (
      <SubscriptionGate
        requiredTier={2}
        featureName="CQC Centre"
        areNotIs
        caption="See your inspection-readiness evidence, gaps and actions in one place."
        benefits={[
          'Continuously track evidence already in AmbuNet against a CQC-aligned framework.',
          'Spot expired, missing or weak evidence before it becomes a finding.',
          'Fix gaps at source via deep links, or assign them to a teammate.',
          'Generate a shareable CQC evidence pack on demand.',
        ]}
      />
    ),
    children: [
      { path: '/cqc-centre', element: <Dashboard />, title: 'CQC Centre' },
      { path: '/cqc-centre/evidence', element: <EvidenceLibrary />, title: 'CQC Evidence' },
      { path: '/cqc-centre/gaps', element: <GapsList />, title: 'CQC Gaps' },
      { path: '/cqc-centre/my-gaps', element: <MyGaps />, title: 'My CQC Gaps' },
      { path: '/cqc-centre/compliance', element: <ComplianceQuestions />, title: 'CQC Compliance' },
      { path: '/cqc-centre/settings', element: <CqcSettings />, title: 'CQC Settings'},
      { path: '/cqc-centre/pack', element: <CqcPackPage />, title: 'CQC Pack' },
      { path: '/cqc-centre/registration', element: <RegistrationDashboard />, title: 'CQC Registration' },
      { path: '/cqc-centre/registration/activities', element: <ActivitiesList />, title: 'CQC Activities' },
      { path: '/cqc-centre/registration/assessments', element: <AssessmentsList />, title: 'CQC Assessments' },
      { path: '/cqc-centre/registration/statement-of-purpose', element: <SopBuilder />, title: 'CQC Purpose' },
      { path: '/cqc-centre/registration/statement-of-purpose/pack', element: <SopPackPage />, title: 'CQC Purpose' },
      { path: '/cqc-centre/registration/settings', element: <RegistrationSettings />, title: 'CQC Registration' },
    ],
  },
]
